import React from "react";
import "./InfoFragment.scss";
import { InfoFragmentImage, YearInfoContentImage } from "./InfoFragmentImage/InfoFragmentImage";

interface IProps {
    info: {
        text: string;
        image?: YearInfoContentImage,
        imgPos?: 'left' | 'right',
    },
    visible: boolean;
}

export function InfoFragment({ info, visible }: IProps) {
    const lines = info.text.split("\n").length;
    const classes = [
        'info-fragment-wrapper',
        ...(visible ? ['visible'] : []),
        `lines-${lines}`,
        ...(info.image ? ['has-image'] : []),
    ]
    return (
        <div className={classes.join(' ')}>
            <div className="info-fragment-inner">
                <div className="info-fragment-html" dangerouslySetInnerHTML={{__html: info.text.split('\n').join('<br />')}} />
                {info.image ? <InfoFragmentImage image={info.image} position={info.imgPos as 'left' | 'right'} /> : null}
            </div>
        </div>
    )
}
